import { render, staticRenderFns } from "./FieldSelector.vue?vue&type=template&id=1f394087&scoped=true&lang=pug"
import script from "./FieldSelector.vue?vue&type=script&lang=js"
export * from "./FieldSelector.vue?vue&type=script&lang=js"
import style0 from "./FieldSelector.vue?vue&type=style&index=0&id=1f394087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f394087",
  null
  
)

export default component.exports